// extracted by mini-css-extract-plugin
module.exports = {"darkBackground":"_1cIGD","root":"_3s42h","title":"_2Drqd","paragraph":"_3clrI"};